import { UseMutationOptions } from '@tanstack/react-query';

import { CommonSuccess, GenericFailure } from '@playq/services-shared';
import { Environment } from '@playq/octopus-common';

import { useEitherMutation } from '/api/service-hooks';
import { SupportContentType, IBeetleWithTags } from '/component/Support/BeetlesLookup/types';

import { methods } from './serviceHandlerRequest';

export const useUpdateTags = (
  type: SupportContentType,
  options?: UseMutationOptions<CommonSuccess, GenericFailure | Error, { ids: IBeetleWithTags[]; env: Environment }>
) => {
  const service = methods(type);
  return useEitherMutation(({ ids, env }) => service.updateTags(ids, env), {
    ...options,
  });
};
